import React, {useState, useEffect} from 'react';
import Selection from "@molecules/selection/selection";
import {FilterDispatcherContext} from "@providers/filters";
import {UpdateSelectionOptions} from "@hooks/selection.options";
import {getNorthCitiesIds} from "@models/area";
import {checkRedirectNorthCitiesPropertyTypes} from "../../property/helpers/search_helper";
import {getDistrictOptions} from "@hooks/districts";
import {getTypesOptions} from "@hooks/types";
import {getDealTypeOptions} from "@hooks/deal_types";
import {isEmpty} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import PinIcon from '@icons/pin.svg';

function CitiesSelection(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {options, selected_items} = props.items;
    const {selected_filters, isBadeSaba} = props;

    const [northCitiesIds, setNorthCitiesIds] = useState([]);

    async function handleChange(data) {
        if (typeof data.items !== "undefined") {
            const city_id = data.items[0];

            if (!isEmpty(selected_items) && !isEmpty(selected_items[0]) && city_id === selected_items[0]) {
                return false;
            }

            const new_option = await UpdateSelectionOptions(options, data);

            await filterDispatcher({
                type: 'CITIES_OPTIONS',
                payload: {
                    cities: new_option,
                    just_cities: true
                }
            });

            setTimeout(async () => {
                const districts = await getDistrictOptions(new_option.selected_items[0]);
                const new_districts = await UpdateSelectionOptions(districts.options, {items: (!isEmpty(selected_filters) && !isEmpty(selected_filters['districts'])) ? selected_filters['districts'] : []});

                const selectedDealType = (!isEmpty(selected_filters) && !isEmpty(selected_filters['deal_type'])) ? selected_filters['deal_type'] : '';
                let selectedTypes = (!isEmpty(selected_filters) && !isEmpty(selected_filters['types'])) ? selected_filters['types'] : [];

                if (inArray(city_id, northCitiesIds)) {
                    selectedTypes = checkRedirectNorthCitiesPropertyTypes(selectedTypes)
                }

                const types = await getTypesOptions(new_option.selected_items[0], selectedDealType);
                const new_types = await UpdateSelectionOptions(types.options, {items: selectedTypes});

                const dealTypes = await getDealTypeOptions(new_option.selected_items[0], isBadeSaba);
                const new_deal_types = await UpdateSelectionOptions(dealTypes.options, {items: !isEmpty(selectedDealType) ? [selectedDealType] : []});

                await filterDispatcher({
                    type: 'CITIES_OPTIONS',
                    payload: {
                        just_cities: false,
                        cities: new_option,
                        districts: new_districts,
                        types: new_types,
                        deal_type: new_deal_types
                    }
                });
            }, 400)
        }
    }

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, []);

    return (
        <div className={typeof props.className !== "undefined" ? props.className : ''}>
            <Selection
                type="single"
                name={props.name !== undefined ? props.name : 'city_id'}
                searchable
                clearabel={false}
                options={options}
                selected_items={selected_items}
                label="شهر"
                loading={false}
                icon={<PinIcon/>}
                onChange={(data) => handleChange(data)}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
                disabled={(!isEmpty(props.disabled) && props.disabled)}
            />
        </div>
    )
}

export default CitiesSelection;
